import { render, staticRenderFns } from "./ConfirmReset.vue?vue&type=template&id=ed03e044&lang=pug"
import script from "./ConfirmReset.vue?vue&type=script&lang=ts"
export * from "./ConfirmReset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports